/** Cognito/PreTokenGen pode enviar bool ou string ("true", "True"). */
export function isCompleteRegisterClaim(value: unknown): boolean {
    if (value === true) {
        return true;
    }

    if (typeof value === "string") {
        return value.toLowerCase() === "true";
    }

    return false;
}
